import HeaderProps from "./_header-props";

class HeaderShared {
    getSiblingLists($list) {
        let $parent;

        // find the direct parent list to which this sublist belongs
        // if the current list has an id of 'search-nav', then set the parent to the root-nav, even though it is not
        // a parent list in the dom tree. It should behave that way in this case.
        if (
            $list.id === "search-nav" ||
            $list.closest("[data-header-search-results]")
        ) {
            $parent = HeaderProps.$header.querySelector("#root-nav");
        } else {
            $parent = $list.parentElement.closest("[data-list-transition]");
        }
        console.assert($parent, "No parent found for list");

        // get all descendant lists of the parent list
        const $allDescendantListsOfParent = [
            ...$parent.querySelectorAll("[data-list-transition]"),
        ];

        // if the parent is the root-nav, then add the search-nav to the list of descendants for it should behave
        // like a descendant in this case
        if ($parent.id === "root-nav") {
            const $searchNav = HeaderProps.$header.querySelector("#search-nav");
            $allDescendantListsOfParent.push($searchNav);
        }

        // filter out all descendants that are not direct children of the parent list
        return [...$allDescendantListsOfParent].filter(($descendant) => {
            let $localParent = $descendant.parentElement.closest(
                "[data-list-transition]",
            );

            // if the descendant is the search-nav, then set the parent to the root-nav.
            if ($descendant.id === "search-nav") {
                $localParent = HeaderProps.$header.querySelector("#root-nav");
            }

            return $localParent === $parent;
        });
    }

    closeSiblingLists($list, shallow = false) {
        const $siblings = this.getSiblingLists($list);
        $siblings.forEach(($sibling) => {
            if ($sibling !== $list) {
                $sibling.setTransitionOut(shallow);
            }
        });
    }

    /*
     * the toggles of the sections are not inside their corresponding lists.
     * this method changes the $sibling of sections to the container element of both the section and the toggle
     */
    transformListSoSectionListsAreGroupedWithTheirToggles($lists) {
        return $lists.map(($list) => {
            if (this.parentIsRootNav($list)) {
                return $list.parentElement;
            }
            return $list;
        });
    }

    parentIsRootNav($list) {
        return (
            $list.parentElement.closest("[data-list-transition]")?.id ===
            "root-nav" ?? false
        );
    }
}

export default new HeaderShared();
